<template>
  <div class="bg-gray-900 rounded-lg p-2 mt-4">
    <apexchart type="treemap" :options="options" :series="series"></apexchart>
  </div>

  <div class="bg-gray-900 rounded-lg p-4 mt-4">
    <table class="table-auto text-white w-full divide-y divide-gray-400">
      <tr>
        <th class="text-right py-2">نام غذا</th>
        <th class="text-left">مقدار</th>
        <th class="text-left">مبلغ</th>
      </tr>
      <tr
          v-for="food in tableData"
          :key="food">
        <th class="text-xs text-right py-3">{{ food.name }}</th>
        <td class="text-left text-sm">{{ this.$helper.priceFormatter(food.qty, false) }}</td>
        <td class="text-left text-sm">{{ this.$helper.priceFormatter(food.mab, false) }}</td>
      </tr>

    </table>
  </div>
</template>

<script>
import {getFoodTreeMap} from "../../API/API";

export default {
  name: "FoodTreemap",
  props: ['month', 'day'],
  data() {
    return {
      tableData: [],
      options: {
        fontFamily: 'iransans',
        colors: ['#ef4444'],
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#fff', '#eee', '#aaa']
          }
        },
        tooltip: {
          theme: 'dark'
        },
      },
      series: [
        {
          data: []
        },
      ]
    }
  },
  created() {
    this.getReports()
  },
  methods: {
    getReports() {
      this.series = [{data: []}]
      this.tableData = []
      getFoodTreeMap('month', '', '', this.month, this.day)
          .then(resp => {
            resp.data.result.yaxis.forEach((item, index, yaxis) => {
              // Only Quantity Values for the Treemap Chart
              if (item.numberType === 'qty') {
                this.series[0].data.push({
                  x: item.name,
                  y: item.data[0]
                })
              }

              // Merge Quantity and Price into single array for table
              if (index + 1 < yaxis.length && item.name === yaxis[index +1].name) {
                this.tableData.push({
                  name: item.name,
                  mab: item.data[0],
                  qty: yaxis[index +1].data[0]
                })
              }

            })
          })
    }
  },
  watch: {
    day() {
      if (this.day !== '')
        this.getReports()
    },
    month() {
      this.getReports()
    }
  }
}
</script>

<style scoped>

</style>